import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">
        At Hayya, we value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, disclose, and safeguard your data when you visit our website or use our services.
      </p>
      <p className="mb-4">
        We may collect personal information such as your name, email address, phone number, and payment details when you register on our site, place an order, subscribe to our newsletter, or fill out a form. This information is used to process transactions, send periodic emails, and improve our services.
      </p>
      <p className="mb-4">
        We also collect non-personal information such as browser type, operating system, and IP address to analyze trends, administer the site, and gather demographic information. This helps us understand how our visitors use our website and allows us to enhance the user experience.
      </p>
      <p className="mb-4">
        We implement a variety of security measures to maintain the safety of your personal information. However, please note that no method of transmission over the Internet or electronic storage is 100% secure. While we strive to protect your personal data, we cannot guarantee its absolute security.
      </p>
      <p className="mb-4">
        We do not sell, trade, or otherwise transfer your personal information to outside parties without your consent, except to trusted third parties who assist us in operating our website, conducting our business, or servicing you, as long as those parties agree to keep this information confidential.
      </p>
      <p className="mb-4">
        By using our site, you consent to our privacy policy. If we decide to change our privacy policy, we will update the modification date below. This policy was last modified on 06/9/2024.
      </p>
      <p className="mb-4">
        If you have any questions about this privacy policy, please contact us at Contact@hayya.tn.
      </p>

      <div className="mt-8">
        <Link to="/signin" className="bg-pink-600 hover:bg-pink-700 text-white font-bold py-1 px-2 rounded">
          Back
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
